/*
 * View for the topic label modal
 */

define(["marionette", "./template/authoringRulesTemplate.html"], function (
  Marionette,
  AuthoringRulesTemplate,
) {
  var AuthoringRulesView = {};

  AuthoringRulesView.authoringRulesView = Marionette.ItemView.extend({
    className: "row-fluid",
    template: AuthoringRulesTemplate,
    triggers: {
      "click #chkDeleteAll": "click:allowDeleteAll",
      "click #chkDeleteCategoryCodes": "click:allowDeleteCategoryCodes",
      "click #chkDeleteTopic": "click:allowDeleteTopic",
      "click #chkDeleteTopicExamples": "click:allowDeleteTopicExamples",
      "click #chkEditAll": "click:allowEditAll",
      "click #chkEditCategoryCodes": "click:allowEditCategoryCodes",
      "click #chkEditTopicExamples": "click:allowEditTopicExamples",
      "click #chkEditTopicFolder": "click:allowEditTopicFolder",
      "click #chkEditTopicLabels": "click:allowEditTopicLabels",
      "click #chkEditTopicName": "click:allowEditTopicName",
      "click #chkEditTopicStatus": "click:allowEditTopicStatus",
      "click #chkViewAll": "click:allowViewAll",
      "click #chkViewCategoryCodes": "click:allowViewCategoryCodes",
      "click #chkViewTopicExamples": "click:allowViewTopicExamples",
      "click #chkViewTopicLabels": "click:allowViewTopicLabels",
    },
  });

  return AuthoringRulesView;
});
